import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Add Stroke
 */

export default function AddStrokeIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M8.53334 0.533333C8.53334 0.238781 8.29455 0 8 0C7.70545 0 7.46667 0.238781 7.46667 0.533333V7.46664H0.533333C0.238782 7.46664 0 7.70542 0 7.99997C0 8.29452 0.238782 8.5333 0.533333 8.5333H7.46667V15.4667C7.46667 15.7612 7.70545 16 8 16C8.29455 16 8.53334 15.7612 8.53334 15.4667V8.5333H15.4667C15.7612 8.5333 16 8.29452 16 7.99997C16 7.70542 15.7612 7.46664 15.4667 7.46664H8.53334V0.533333Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
